<template>
  <va-edit-layout>
    <country-form :id="id" :title="title" :item="item"></country-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ["id", "title", "item"],
};
</script>
